import VerticalSpacer from 'components/Common/Spacing/VerticalSpacer'
import BodyText from 'components/Luxkit/Typography/BodyText'
import Heading from 'components/Luxkit/Typography/Heading'
import React from 'react'
import ModalBase from 'components/Luxkit/Modal/ModalBase'
import ModalBody from 'components/Luxkit/Modal/ModalBody'
import ModalImageThumbnail from 'components/Luxkit/Modal/ModalImageThumbnail'
import ModalContent from 'components/Luxkit/Modal/ModalContent'
import ModalHeader from 'components/Luxkit/Modal/ModalHeader'
import LoyaltyTierCallOutBanner from 'loyalty/components/LoyaltyTierCallOutBanner'
import getLoyaltyTierDisplayName from 'loyalty/selectors/getLoyaltyTierDisplayName'
import Plural from 'components/utils/Formatters/Plural'
import FormatCurrency from 'components/Common/FormatCurrency'
import { ImageParams } from 'components/Common/ResponsiveImage/ResponsiveImage'
import LineCameraIcon from 'components/Luxkit/Icons/line/LineCameraIcon'

const imageParams: ImageParams = {
  aspectRatio: '16:8',
  mobileWidth: '720px',
  fit: 'center',
}

interface Props {
  image: App.Image
  tier: App.LoyaltyTier
  benefitValue: number
  numberOfBenefitRemaining: number
}

function LandingPageLoyaltyTravelShootCreditBenefitsModal(props: Props) {
  const { image, tier, benefitValue, numberOfBenefitRemaining } = props

  return (
    <ModalBase size="L">
      <ModalHeader title="Pro photos on your trip" />
      <ModalBody>
        <ModalImageThumbnail image={image} imageParams={imageParams} />
        <ModalContent>
          <VerticalSpacer gap={32}>
            {!!numberOfBenefitRemaining && <LoyaltyTierCallOutBanner
              tier={tier}
              subtitle={<BodyText variant="small">{getLoyaltyTierDisplayName(tier)} Member Benefit</BodyText>}
              icon={<LineCameraIcon />}
            >
              <BodyText variant="medium">
                You have {numberOfBenefitRemaining > 1 ? `${numberOfBenefitRemaining}x` : 'a'}{' '}
                <FormatCurrency value={benefitValue} format="dynamic" />{' '}
                Travelshoot <Plural count={numberOfBenefitRemaining} singular="voucher" />
              </BodyText>
            </LoyaltyTierCallOutBanner>}
            <BodyText variant="large">
              Make the memories last. Use your Travelshoot voucher to book a professional photo session at your destination—perfect for couples, families, or solo travellers.
            </BodyText>
            <VerticalSpacer gap={8}>
              <Heading variant="heading4">How it works</Heading>
              <BodyText variant="large">
                Book a professional photoshoot at your holiday destination through Travelshoot.<br /><br />
                Choose your location, match with a local photographer, and capture unforgettable moments with a one-hour shoot.{' '}
                Within 48 hours you’ll receive a couple sneak peeks and the full album within 7 days.<br /><br />
                Use your <FormatCurrency value={benefitValue} format="dynamic" /> voucher at checkout and receive{' '}
                a gallery of professionally edited photos to keep forever.<br /><br />
                A Travelshoot can be booked on its own (doesn't need to be attached to a hotel booking){' '}
                and our friendly customer service team can organise your voucher post-booking.
              </BodyText>
            </VerticalSpacer>
          </VerticalSpacer>
        </ModalContent>
      </ModalBody>
    </ModalBase>
  )
}

export default LandingPageLoyaltyTravelShootCreditBenefitsModal
